import { cn } from '../lib/cn'

/**
 * Filtro — componente 08.
 * Segmentos em pílula reta com o NÚMERO do que existe em cada um ("Pendentes 6", "Todos 331").
 * Um filtro sem número é um botão; com número, é diagnóstico.
 * A tela abre no filtro que revela trabalho pendente, não em "Todos". A escolha sobrevive à navegação.
 */

export interface FilterSegmentOption<T extends string = string> {
  value: T
  label: string
  count?: number
}

export interface FilterSegmentsProps<T extends string = string> {
  options: FilterSegmentOption<T>[]
  value: T
  onChange: (value: T) => void
  /** Nome acessível do grupo. */
  label?: string
  className?: string
}

export function FilterSegments<T extends string = string>({
  options,
  value,
  onChange,
  label = 'Filtrar',
  className,
}: FilterSegmentsProps<T>) {
  return (
    <div
      role="group"
      aria-label={label}
      data-slot="filter-segments"
      className={cn('flex flex-wrap items-center gap-2', className)}
    >
      {options.map((option) => {
        const active = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(option.value)}
            className={cn(
              'font-body text-eyebrow inline-flex min-h-8 cursor-pointer items-center gap-[6px] px-3 py-[9px] font-light tracking-normal transition-[border-color,background-color]',
              // Abaixo de desk o alvo de toque é de 48px; o segmento não cresce.
              "max-desk:relative max-desk:after:absolute max-desk:after:inset-x-0 max-desk:after:top-1/2 max-desk:after:h-touch max-desk:after:-translate-y-1/2 max-desk:after:content-['']",
              active
                ? 'bg-ink text-pampas'
                : 'border-hairline-heavy text-ink hover:border-ink border',
            )}
          >
            {option.label}
            {option.count !== undefined ? (
              <>
                {' '}
                <span className={active ? 'text-pampas' : 'text-secondary'}>{option.count}</span>
              </>
            ) : null}
          </button>
        )
      })}
    </div>
  )
}
